import { render, staticRenderFns } from "./nitrogen.vue?vue&type=template&id=863f0500&scoped=true&"
import script from "./nitrogen.vue?vue&type=script&lang=js&"
export * from "./nitrogen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863f0500",
  null
  
)

export default component.exports